// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeleteNode__container___eH9HG {
    align-items: center;
    display: inline-flex;
    font-size: 11px;
    font-weight: normal;
    white-space: nowrap;
}

.DeleteNode__noMargin___riC75 {
    margin: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DeleteNode__container___eH9HG`,
	"noMargin": `DeleteNode__noMargin___riC75`
};
module.exports = ___CSS_LOADER_EXPORT___;
